/* eslint-disable */
import React from "react";
import styled from "@emotion/styled";
import content1pre1 from "@/assets/images/linzhitaohua2022/content1pre1.jpg";
import content1 from "@/assets/images/linzhitaohua2022/content1.jpg";
import content2 from "@/assets/images/linzhitaohua2022/content2.jpg";
import content3 from "@/assets/images/linzhitaohua2022/content3.jpg";
import content4 from "@/assets/images/linzhitaohua2022/content4.jpg";
import content5 from "@/assets/images/linzhitaohua2022/content5.jpg";
import content6 from "@/assets/images/linzhitaohua2022/content6.jpg";
import headermain from "@/assets/images/linzhitaohua2022/headermain.png";
import bottom from "@/assets/images/linzhitaohua2022/bottom.png";
import headerimg from "@/assets/images/linzhitaohua2022/header.jpg";
import bottomBack from "@/assets/images/linzhitaohua2022/bottomBack.png";
import styles from './mobile.module.scss';


function Linzhimobile() {
  
    return (
        <HomeContainermobile>
            <div className={styles.header} style={{backgroundImage: `url(${headerimg})`}}>
                <img className={styles.headermain_img} src={headermain} />
                <iframe
                    src='https://720yun.com/vr/dff24jsOulw?s=1031207'
                    title="iframe"
                    style={{ width: '100%', border: 0, height:  '100%' }}
                    sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
                    scrolling="auto"
                >
                </iframe>
                <div className={styles.headerbottom}>
                    <div className={styles.headerbottomC}>
                        <div className={styles.intro_item}>
                            <div className={styles.p1}>主办单位：</div>
                            <div className={styles.p2}>中共林芝市委员会 | 林芝市人民政府</div>
                        </div>
                        <div className={styles.intro_item}>
                            <div className={styles.p1}>承办单位：</div>
                            <div className={styles.p2}>林芝市旅游发展局 | 西藏旅游旅信网络科技有限公司  |  720VR创作社区</div>
                        </div>
                        <div className={styles.intro_item}>
                            <div className={styles.p1}>特别合作伙伴：</div>
                            <div className={styles.p2}>小米·云南分公司 | 大疆创新</div>
                        </div>
                    </div>
                </div>
            </div>
            <div className={styles.content}>
                <img className={styles.img_src} src={content1pre1} />
                <img className={styles.img_src} src={content1} />
                <img className={styles.img_src} src={content2} />
                <img className={styles.img_src} src={content3} />
                <img className={styles.img_src} src={content4} />
                <img className={styles.img_src} src={content5} />
                <div className={styles.links}>
                    <div className={styles.linkitem}><a href="https://mp.weixin.qq.com/s?__biz=MzA5NDA4NzY0NQ==&mid=2651196449&idx=1&sn=6c1556452ab3144cc106b7e7bc820f4d&scene=21#wechat_redirect" target="_blank" rel="noreferrer">【官方发布-微林芝 入（返）林疫情防控政策调整提醒】</a></div>
                    <div className={styles.linkitem2}><a href="https://mp.weixin.qq.com/s?__biz=MzIxMzAwMDAxMg==&mid=2649846906&idx=3&sn=33a49f5a62ad1b211fb2384b7ce5ad9f&scene=21#wechat_redirect" target="_blank" rel="noreferrer">【公告 西藏拥有无人驾驶航空器的单位及个人，这份公告请务必详读！】</a></div>
                    <div className={styles.linkitem}><a href="https://www.wenjuan.com/s/UZBZJvrjCx/" target="_blank" rel="noreferrer">【2022林芝桃花节VR全景游大赛支持单位无人机航拍报备-预登记入口 】</a></div>
                </div>
                <img className={styles.img_src} src={content6} />
            </div>

            <div className={styles.bottom} style={{backgroundImage: `url(${bottomBack})`}}>
                <img src={bottom} />
            </div>
        </HomeContainermobile>
    );
}

const HomeContainermobile = styled.div`
    width: 100%;
    background-color: #fff;
    position: relative;
`;

export default Linzhimobile;
